import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  SelectManualService: {},
  Rebook: {
    airline_name: '',
    name_service: '',
    date: '',
    sta: '',
    fight_number: '',
    from_airport: '',
    to_airport: ''
  },
  PaxsGroup: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
